import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  startAttemptAPI,
  submitAnswerAPI,
  submitAttemptAPI,
  getMyAttemptsAPI,
  getAttemptDetailsAPI,
  getCompletedAttemptByQuizAPI
} from "../../services/quizAttempt";

export let startAttempt = createAsyncThunk(
  "quizAttempt/start",
  async (quizId, thunkApi) => {
    try {
      let response = await startAttemptAPI(quizId);
      return response.data;
    } catch (error) {
      let errorMsg = error.response?.data?.msg || error.response?.data?.message;
      return thunkApi.rejectWithValue(errorMsg ? errorMsg : error.message);
    }
  }
);

export let submitAnswer = createAsyncThunk(
  "quizAttempt/submitAnswer",
  async ({ attemptId, questionId, answer }, thunkApi) => {
    try {
      let response = await submitAnswerAPI(attemptId, questionId, answer);
      return response.data;
    } catch (error) {
      let errorMsg = error.response?.data?.msg || error.response?.data?.message;
      return thunkApi.rejectWithValue(errorMsg ? errorMsg : error.message);
    }
  }
);

export let submitAttempt = createAsyncThunk(
  "quizAttempt/submit",
  async ({ attemptId, timeSpent }, thunkApi) => {
    try {
      let response = await submitAttemptAPI(attemptId, timeSpent);
      return response.data;
    } catch (error) {
      let errorMsg = error.response?.data?.msg || error.response?.data?.message;
      return thunkApi.rejectWithValue(errorMsg ? errorMsg : error.message);
    }
  }
);

export let getMyAttempts = createAsyncThunk(
  "quizAttempt/my",
  async (_, thunkApi) => {
    try {
      let response = await getMyAttemptsAPI();
      return response.data;
    } catch (error) {
      let errorMsg = error.response?.data?.msg || error.response?.data?.message;
      return thunkApi.rejectWithValue(errorMsg ? errorMsg : error.message);
    }
  }
);

export let getAttemptDetails = createAsyncThunk(
  "quizAttempt/details",
  async (attemptId, thunkApi) => {
    try {
      let response = await getAttemptDetailsAPI(attemptId);
      return response.data;
    } catch (error) {
      let errorMsg = error.response?.data?.msg || error.response?.data?.message;
      return thunkApi.rejectWithValue(errorMsg ? errorMsg : error.message);
    }
  }
);

export let getCompletedAttemptByQuiz = createAsyncThunk(
  "quizAttempt/completedByQuiz",
  async (quizId, thunkApi) => {
    try {
      let response = await getCompletedAttemptByQuizAPI(quizId);
      return response.data;
    } catch (error) {
      let errorMsg = error.response?.data?.msg || error.response?.data?.message;
      return thunkApi.rejectWithValue(errorMsg ? errorMsg : error.message);
    }
  }
);

let initialState = {
  loading: false,
  attempts: [],
  currentAttempt: null,
  completedAttempt: null,
  error: null,
  errorMsg: "",
  successMsg: ""
};

let quizAttemptSlice = createSlice({
  name: "quizAttempt",
  initialState,
  reducers: {
    clearAttempt: (state, action) => {
      state.loading = false;
      state.error = null;
      state.errorMsg = "";
      state.successMsg = "";
    },
    setCurrentAttempt: (state, action) => {
      state.currentAttempt = action.payload;
    }
  },
  extraReducers: {
    [startAttempt.pending]: (state, action) => {
      state.loading = true;
    },
    [startAttempt.fulfilled]: (state, action) => {
      state.loading = false;
      state.currentAttempt = action.payload.attempt;
    },
    [startAttempt.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.errorMsg = "Failed to start quiz attempt";
    },
    [submitAnswer.pending]: (state, action) => {
      state.loading = true;
    },
    [submitAnswer.fulfilled]: (state, action) => {
      state.loading = false;
      state.currentAttempt = action.payload.attempt;
    },
    [submitAnswer.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.errorMsg = "Failed to submit answer";
    },
    [submitAttempt.pending]: (state, action) => {
      state.loading = true;
    },
    [submitAttempt.fulfilled]: (state, action) => {
      state.loading = false;
      state.currentAttempt = action.payload.attempt;
      state.successMsg = "Quiz submitted successfully";
    },
    [submitAttempt.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.errorMsg = "Failed to submit quiz";
    },
    [getMyAttempts.pending]: (state, action) => {
      state.loading = true;
    },
    [getMyAttempts.fulfilled]: (state, action) => {
      state.loading = false;
      state.attempts = action.payload.attempts;
    },
    [getMyAttempts.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    [getAttemptDetails.pending]: (state, action) => {
      state.loading = true;
    },
    [getAttemptDetails.fulfilled]: (state, action) => {
      state.loading = false;
      state.currentAttempt = action.payload.attempt;
    },
    [getAttemptDetails.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    [getCompletedAttemptByQuiz.pending]: (state, action) => {
      state.loading = true;
    },
    [getCompletedAttemptByQuiz.fulfilled]: (state, action) => {
      state.loading = false;
      state.completedAttempt = action.payload.attempt;
    },
    [getCompletedAttemptByQuiz.rejected]: (state, action) => {
      state.loading = false;
      state.completedAttempt = null;
      state.error = action.payload;
    },
  }
});

let quizAttemptReducer = quizAttemptSlice.reducer;
export let { clearAttempt, setCurrentAttempt } = quizAttemptSlice.actions;
export default quizAttemptReducer;

